import { createAsyncThunk } from "@reduxjs/toolkit";
import { logoutUser } from "./authThunks";

const API_URL = `${process.env.REACT_APP_API_BASE}/api/charities`;

export const fetchCharities = createAsyncThunk(
  "charities/fetchAll",
  async (_, thunkAPI) => {
    const res = await fetch(API_URL, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "partner",
      },
    });

    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }

    const json = await res.json();
    if (!res.ok) {
      throw new Error(json?.message || "Fetch charities failed");
    }
    return json;
  }
);

export const createCharity = createAsyncThunk(
  "charities/create",
  async (data, thunkAPI) => {
    const res = await fetch(API_URL, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "partner",
      },
      body: JSON.stringify(data),
    });

    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res.ok) {
      throw new Error(json?.message || "Create charity failed");
    }
    return json;
  }
);

export const updateCharity = createAsyncThunk(
  "charities/update",
  async ({ id, data }, thunkAPI) => {
    const res = await fetch(`${API_URL}/?_id=${id}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "partner",
      },
      body: JSON.stringify(data),
    });

    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res.ok) {
      throw new Error(json?.message || "Update charity failed");
    }
    return json;
  }
);

export const deleteCharity = createAsyncThunk(
  "charities/delete",
  async (id, thunkAPI) => {
    const res = await fetch(`${API_URL}/?_id=${id}`, {
      method: "DELETE",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "partner",
      },
      body: JSON.stringify({ id }), // ✅ pass only id
    });

    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res.ok) {
      throw new Error(json?.message || "Delete charity failed");
    }

    return { id }; // return the deleted id so slice can update state
  }
);

export const getCharityByParam = createAsyncThunk(
  "charities/getByParam",
  async (params, thunkAPI) => {
    const query = new URLSearchParams(params).toString();
    const res = await fetch(`${API_URL}/getByParam?${query}`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "partner",
      },
    });

    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }

    const json = await res.json();
    if (!res.ok) {
      throw new Error(json?.message || "Get charity failed");
    }
    return json;
  }
);
